import script from "./SimulationInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./SimulationInfo.vue?vue&type=script&setup=true&lang=js"

import "./SimulationInfo.vue?vue&type=style&index=0&id=56b58012&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-56b58012"]])

export default __exports__